export default {
  confirmText: '确定',
};
